module.exports = "mutation deleteSales($adviceRequestId:String!,$revenueId:String!){deleteSales(adviceRequestId:$adviceRequestId,revenueId:$revenueId)}"